let rb_breaker       = 0;
let rb_breaker_limit = 3;
$(document).ready(function() {
    let $body = $('body');
    let startX, startY, endX, endY;

    function translate(){
      if (window.option_translations !== undefined && Array.isArray(window.option_translations)) {
          for (let option_translation of window.option_translations) {
              $body.find('.boost-pfs-filter-option-value').each(function() {
                  $(this).html($(this).html().split(option_translation.name_en).join(option_translation.name_fr));
              });
          }
      }
  
      $body.find('.boost-pfs-filter-option-title-text').each(function() {
          $(this).html($(this).html().split('Size').join('Pointure'));
          $(this).html($(this).html().split('Type').join('Type'));
          $(this).html($(this).html().split('Style').join('Style'));
          $(this).html($(this).html().split('Cold rating').join('Cote de confort'));
          $(this).html($(this).html().split('Colour').join('Couleur'));
          $(this).html($(this).html().split('Price').join('Prix'));
          $(this).html($(this).html().split('Heel type').join('Type de talon'));
          $(this).html($(this).html().split('Heel height').join('Hauteur du talon'));
          $(this).html($(this).html().split('Gender').join('Genre'));
          $(this).html($(this).html().split('Age groups').join('Groupe d\'âge'));
          $(this).html($(this).html().split('Subcategory').join('Sous-catégorie'));
          $(this).html($(this).html().split('Brand').join('Marque'));
          //Add filter names translations here
      }); 

      $body.find('.boost-pfs-filter-mobile-toolbar-middle').each(function() {
          $(this).html($(this).html().split('Size').join('Pointure'));
          $(this).html($(this).html().split('Type').join('Type'));
          $(this).html($(this).html().split('Style').join('Style'));
          $(this).html($(this).html().split('Cold rating').join('Cote de confort'));
          $(this).html($(this).html().split('Colour').join('Couleur'));
          $(this).html($(this).html().split('Price').join('Prix'));
          $(this).html($(this).html().split('Heel type').join('Type de talon'));
          $(this).html($(this).html().split('Heel height').join('Hauteur du talon'));
          $(this).html($(this).html().split('Gender').join('Genre'));
          $(this).html($(this).html().split('Age groups').join('Groupe d\'âge'));
          $(this).html($(this).html().split('Subcategory').join('Sous-catégorie'));
          $(this).html($(this).html().split('Brand').join('Marque'));
          //Add filter names translations here
      }); 
      
    }

    window.translate = translate;

    $body.find('.lazyLoader').each(function() {if ($(this).hasClass('slide-video')) {this.play();} });

    if (theme.locale == 'fr') {
        setTimeout(function() {
            setInterval(function() {
                $body.find('.product-block__type').each(function() {
                    let str = $(this).text();
                    $(this).text(str.charAt(0).toUpperCase() + str.slice(1).toLowerCase());
                });
            }, 100);
        }, 1600);

        setTimeout(function() {

            translate();

            setInterval(function() {
                $body.find('.refine-by-option').each(function() {
                    $(this).html($(this).html().split('Size').join('Pointure'));
                    $(this).html($(this).html().split('Type').join('Type'));
                    $(this).html($(this).html().split('Style').join('Style'));
                    $(this).html($(this).html().split('Cold rating').join('Cote de confort'));
                    $(this).html($(this).html().split('Colour').join('Couleur'));
                    $(this).html($(this).html().split('Price').join('Prix'));
                    $(this).html($(this).html().split('Heel type').join('Type de talon'));
                    $(this).html($(this).html().split('Heel height').join('Hauteur du talon'));
                    $(this).html($(this).html().split('Gender').join('Genre'));
                    $(this).html($(this).html().split('Age groups').join('Groupe d\'âge'));
                    $(this).html($(this).html().split('Subcategory').join('Sous-catégorie'));
                    $(this).html($(this).html().split('Brand').join('Marque'));
                    //Add filter names translations here
                });
                if (window.color_translations !== undefined && Array.isArray(window.color_translations)) {
                    for (let color_translation of window.color_translations) {
                        $body.find('.color-name').each(function() {
                            $(this).html($(this).html().toLowerCase().split(color_translation.color_en).join(color_translation.color_fr));
                        });
                        $body.find('.refine-by-value').each(function() {
                            $(this).html($(this).html().toLowerCase().split(color_translation.color_en).join(color_translation.color_fr));
                        });
                    }
                }
                if (window.option_translations !== undefined && Array.isArray(window.option_translations)) {
                    for (let option_translation of window.option_translations) {
                        $body.find('.refine-by-value').each(function() {
                            if ($(this).html().toLowerCase().includes(option_translation.name_en.toLowerCase())) {
                                $(this).html(option_translation.name_fr);
                            }
                        });
                    }
                }
            }, 25);
        }, 1200);
    }

    $body.find('.options--pointure').each(function() {
        $(this).addClass('options--size');
    });

    // if(theme.locale == 'en'){
    //   $holiday_message = "<div style='font-size:18px; font-weight:bold; text-align:center; margin-bottom:35px;'>Special opening hours on December 26th : please call your local store for exact hours</div>";
    //   $("#store-locator-title").html($holiday_message+"FIND A YELLOW STORE NEAR YOU");
    // }else{
    //   $holiday_message = "<div style='font-size:18px; font-weight:bold; text-align:center; margin-bottom:35px;'>Heures d'ouverture spéciales le 26 décembre : pour les heures exactes, veuillez appeler votre magasin local</div>";
    //   $("#store-locator-title").html($holiday_message+"TROUVER UN MAGASIN YELLOW PRÈS DE CHEZ VOUS");
    // }

    setInterval(function() {
        $body.find('.pagination').find('.next').each(function() {
            $(this).html('<svg class="Icon Icon--select-arrow-right " role="presentation" viewBox="0 0 11 18"><path d="M1.5 1.5l8 7.5-8 7.5" stroke-width="2" stroke="currentColor" fill="none" fill-rule="evenodd" stroke-linecap="square"></path></svg>');
        });
        $body.find('.pagination').find('.prev').each(function() {
            $(this).html('<svg class="Icon Icon--select-arrow-left " role="presentation" viewBox="0 0 11 18"><path d="M9.5 1.5L1.5 9l8 7.5" stroke-width="2" stroke="currentColor" fill="none" fill-rule="evenodd" stroke-linecap="square"></path></svg>');
        });
    }, 100);

    if ($(window).width() > 800) {
        setInterval(function() {
            let $box = $body.find('.fancybox-content');
            if ($box.length) {
                $box.each(function() {
                    if ($(this).attr('id') !== undefined) {
                        if ($(this).attr('id').includes('instagram_detail')) {
                            $(this).attr('style', $(this).attr('style') + '; max-height:550px;');
                        }
                    }
                });
            }
        }, 20);
    }

    let attentive_trigger = getQueryStringParameters();
    if (attentive_trigger.attentive == 'true') {
        setTimeout(function() {
            triggerAttentivePopup();
        }, 800);
    }

    $body.on('click', '.french-switcher', function(e) {
        e.preventDefault();
        window.location.href = $(this).attr('href');
    });

    let $availability_phone = $body.find('#availability-reminder-phone');
    if ($availability_phone.length) {
        $availability_phone.inputmask('(999) 999-9999');
    }

    let $postal_code = $body.find('#availability-reminder-zip');
    if ($postal_code.length) {
        Inputmask('A9A 9A9', {

            placeholder: '-',
            greedy:      false,
            casing:      'upper',
            jitMasking:  true,
        }).mask('#availability-reminder-zip');
    }

    $body.on('click', '#mobile-megamenu-close-btn', function() {
        let $this = this;
        $body.find('.navigation__item--with-children .navigation__link').each(function() {
            if ($(this).attr('aria-expanded') == 'true') {
                $(this).attr('aria-haspopup', 'true');
                $(this).attr('aria-expanded', 'false');
                let $t = $(this);
                $(this).closest('.navigation__item--with-children').removeClass('navigation__item--show-children');
                setTimeout(function() {
                    $t.closest('.navigation__item--with-children').removeClass('navigation__item--show-children');
                    //   $this.click();
                }, 100);
            }

        });
    });

    let $buttons = $body.find('.hero-cta-btn');
    if ($buttons.length == 0) {
        $body.find('.hero-banner-group').remove();
    }
    setInterval(function() {
        rb_breaker++;
    }, 1000);
    $body.on('click', '#rb_breaker', function() {
        $(this).html('✓');
    });
    /*reset-pass*/
    let $reset_pass_form = $body.find('#reset-password-form');
    if ($reset_pass_form.length) {
        let red_url = '/';
        if (theme.locale == 'fr') {
            red_url = '/fr';
        }
        let $_GET = getQueryStringParameters();

        showPreloader();
        if (!validateEmail($_GET.email) || $_GET.token == undefined) {

            window.location.href = red_url;
            return;
        }

        $.ajax({
                   url:      'https://app.yellowshoes.com/api/multipass',
                   method:   'POST',
                   data:     {
                       'action':   'forgot_pass_token_validation',
                       'email':    $_GET.email,
                       token:      decodeURIComponent($_GET.token),
                       'language': theme.locale,
                   },
                   dataType: 'json',
                   success:  function(response_data) {
                       hidePreloader();
                       if (!response_data.success) {
                           new Swal({
                                        title: '',
                                        text:  response_data.error_message,
                                        icon:  'error',
                                    }).then((value) => {
                               window.location.href = red_url;
                           });
                           return;
                       }

                   },
                   error:    function(response_data) {
                       console.log(response_data);
                   },
               });
    }
    $body.on('click', '#reset-password-btn', function() {
        let $_GET = getQueryStringParameters();
        $.ajax({
                   url:      'https://app.yellowshoes.com/api/multipass',
                   method:   'POST',
                   data:     {
                       'action':      'reset_pass',
                       'email':       $_GET.email,
                       password:      $body.find('#customer_password').val().trim(),
                       conf_password: $body.find('#customer_password_confirmation').val().trim(),
                       token:         decodeURIComponent($_GET.token),
                       'language':    theme.locale,
                   },
                   dataType: 'json',
                   success:  function(response_data) {
                       if (!response_data.success) {
                           new Swal({
                                        title: '',
                                        text:  response_data.error_message,
                                        icon:  'error',
                                    });
                           return;
                       }
                       new Swal({
                                    title: '',
                                    text:  '',
                                    icon:  'success',
                                }).then((value) => {
                           window.location.href = response_data.url;
                       });
                   },
                   error:    function(response_data) {
                       console.log(response_data);
                   },
               });
    });

    /*end.reset-pass*/

    $body.on('click', '#mobile-account-sidebar-toggler', function() {
        let $target = $body.find('#mobile-account-sidebar');
        if ($target.attr('style') == 'display:block;') {
            $target.attr('style', '');
        } else {

            $target.attr('style', 'display:block;');
        }
    });
    //   $body.find('#login_popup_password')[0].addEventListener('keypress', function (e) {
    //     if (e.key === 'Enter') {
    //       $body.find('#login-popup-submit-btn')[0].click();
    //     }
    //   });

    $('#login_popup_password').on('keypress', function(e) {
        if (e.key === 'Enter') {
            $('#login-popup-submit-btn').click();
        }
    });

    $body.on('click', '.custom-checkbox-label', function() {
        $(this).closest('.custom-checkbox-container').find('.custom-checkbox')[0].click();
    });

    $body.on('click', '.custom-checkbox', function() {
        let target = $(this).attr('data-target');
        if ($(this).attr('data-type') === 'radio' && !$(this).hasClass('selected')) {
            let name = $(this).attr('data-name');
            $body.find('div[data-name="' + name + '"]').removeClass('selected');
            $body.find(target)[0].checked = true;
            $(this).addClass('selected');
        } else if ($(this).attr('data-type') !== 'radio') {
            if ($(this).hasClass('selected')) {
                $(this).removeClass('selected');
            } else {
                $(this).addClass('selected');
            }
            $body.find(target)[0].checked = !$body.find(target)[0].checked;
        }
    });

    setTimeout(function() {
        $('.featured-product-block').each(function(_index) {
            var element_tags = $(this).attr('data-tags');
            if (element_tags.includes('gender-mens')) {
                element_tags += ' gender-hommes';
            }
            if (element_tags.includes('gender-accessories')) {
                element_tags += ' gender-accessoires';
            }
            $(this).attr('data-tags', element_tags);
        });
    }, 500);
    $body.on('click', '.clickyboxes a', function() {
        setTimeout(function() {
            window.location.href = window.location.href;
        }, 200);
    });

    $body.on('click', '#register-page-submit-btn', function() {

        if (rb_breaker < rb_breaker_limit || $body.find('#login_popup_hp').val().trim() !== '') {
            showLoginCaptcha(false);
            rb_breaker = 0;
            return;
        }
        rb_breaker = 0;
        $body.find('#register-page-form').find('.register-popup-error-msg').hide();
        let can_go = true;
        $body.find('#register-page-submit-btn').addClass('btn-disabled');
        let email = $body.find('#register_page_email').val().trim();
        $body.find('#register-page-form').
              find('input').
              removeClass('register-page-error');
        $body.find('#register-page-form').
              find('input').
              removeClass('register-popup-error');

        $body.find('#register-page-form').find('.register-page-error-msg').hide();
        if (!validateEmail(email)) {
            $body.find('#register_page_email').addClass('register-page-error');
            $body.find('#register_page_email_err_message').show();
            can_go = false;
        }
        let firstName = $body.find('#register_page_first_name').val().trim();
        if (firstName === '') {
            $body.find('#register_page_first_name').addClass('register-page-error');
            $body.find('#register_page_first_name_err_message').show();
            can_go = false;
        }
        let lastName = $body.find('#register_page_last_name').val().trim();
        if (lastName === '') {
            $body.find('#register_page_last_name').addClass('register-page-error');
            $body.find('#register_page_last_name_err_message').show();
            can_go = false;
        }
        let phone_number = $body.find('#register_page_phone').val().trim();
        let password     = $body.find('#register_page_password').val().trim();
        if (password.length < 8) {
            $body.find('#register_page_password').addClass('register-page-error');
            $body.find('#register_page_password_err_message').show();
            can_go = false;
        }
        can_go = true;
        if (!can_go) {
            $body.find('#register-page-submit-btn').removeClass('btn-disabled');
            return;
        } else {
            $.ajax({
                       url:      'https://app.yellowshoes.com/api/multipass',
                       method:   'POST',
                       data:     {
                           'action':         'register-page',
                           first_name:       firstName,
                           last_name:        lastName,
                           'email':          email,
                           password:         password,
                           'language':       theme.locale,
                           phone:            phone_number,
                           signup_for_sms:   $body.find('#register-page-agree-to-get-sms')[0].checked ? '1' : '0',
                           signup_for_email: $body.find('#register-page-agree-to-get-email')[0].checked ? '1' : '0',
                       },
                       dataType: 'json',
                       success:  function(response_data) {
                           if (!response_data.success) {
                               $body.find('#register-page-submit-btn').removeClass('btn-disabled');
                               if (response_data.error_message_selector == undefined) {
                                   $body.find('#login-popup-overlay').hide();
                                   new Swal({
                                                title: '',
                                                text:  response_data.error_message,
                                                icon:  'error',
                                            }).then((value) => {
                                       $body.find('#login-popup-overlay').show();
                                   });
                               } else {
                                   let phone_checkbox_found = false;
                                   for (let selector of response_data.error_fields_selector) {
                                       $body.find(selector).addClass('register-popup-error');
                                   }
                                   for (let selector of response_data.error_message_selector) {
                                       $body.find(selector).show();

                                       if (selector === '#register_page_error_checkbox') {
                                           phone_checkbox_found = true;
                                       }
                                   }
                                   if (phone_checkbox_found) {
                                       $body.find('#register-page-agree-to-get-sms').closest('.custom-checkbox-container').find('.custom-checkbox').attr('style', 'border-color:red;');
                                       $body.find('#register-page-agree-to-get-sms').closest('.custom-checkbox-container').find('.custom-checkbox-label').attr('style', 'color:red;');
                                   } else {
                                       $body.find('#register-page-agree-to-get-sms').closest('.custom-checkbox-container').find('.custom-checkbox').attr('style', '');
                                       $body.find('#register-page-agree-to-get-sms').closest('.custom-checkbox-container').find('.custom-checkbox-label').attr('style', '');
                                   }
                                   $body.find(response_data.error_message_selector).show();
                               }
                               return;
                           }
                           window.location.href = response_data.url;

                       },
                       error:    function(response_data) {
                           $body.find('#register-page-submit-btn').removeClass('btn-disabled');
                           console.log(response_data);
                       },
                   });
        }
    });

    $body.on('click', '#register-popup-submit-btn', function() {
        if (rb_breaker < rb_breaker_limit || $body.find('#login_popup_hp').val().trim() !== '') {
            showLoginCaptcha();
            rb_breaker = 0;
            return;
        }
        rb_breaker = 0;
        let can_go = true;
        $body.find('#register-popup-submit-btn').addClass('btn-disabled');
        let email = $body.find('#register_popup_email').val().trim();
        $body.find('#register-popup-form').
              find('input').
              removeClass('register-popup-error');
        $body.find('#register-popup-form').find('.register-popup-error-msg').hide();
        if (!validateEmail(email)) {
            $body.find('#register_popup_email').addClass('register-popup-error');
            $body.find('#register_popup_email_err_message').show();
            can_go = false;
        }
        let firstName = $body.find('#register_popup_first_name').val().trim();
        if (firstName === '') {
            $body.find('#register_popup_first_name').addClass('register-popup-error');
            $body.find('#register_popup_first_name_err_message').show();
            can_go = false;
        }
        let lastName = $body.find('#register_popup_last_name').val().trim();
        if (lastName === '') {
            $body.find('#register_popup_last_name').addClass('register-popup-error');
            $body.find('#register_popup_last_name_err_message').show();
            can_go = false;
        }
        let phone_number = $body.find('#register_popup_phone').val().trim();
        let password     = $body.find('#register_popup_password').val().trim();
        if (password.length < 8) {
            $body.find('#register_popup_password').addClass('register-popup-error');
            $body.find('#register_popup_password_err_message').show();
            can_go = false;
        }
        can_go = true;
        if (!can_go) {
            $body.find('#register-popup-submit-btn').removeClass('btn-disabled');
            return;
        } else {
            $.ajax({
                       url:      'https://app.yellowshoes.com/api/multipass',
                       method:   'POST',
                       data:     {
                           'action':         'register',
                           first_name:       firstName,
                           last_name:        lastName,
                           'email':          email,
                           password:         password,
                           phone:            phone_number,
                           'language':       theme.locale,
                           signup_for_sms:   $body.find('#register-agree-to-get-sms')[0].checked ? '1' : '0',
                           signup_for_email: $body.find('#register-agree-to-get-email')[0].checked ? '1' : '0',
                       },
                       dataType: 'json',
                       success:  function(response_data) {
                           if (!response_data.success) {
                               $body.find('#register-popup-submit-btn').removeClass('btn-disabled');
                               if (response_data.error_message_selector == undefined) {
                                   $body.find('#login-popup-overlay').hide();
                                   new Swal({
                                                title: '',
                                                text:  response_data.error_message,
                                                icon:  'error',
                                            }).then((value) => {
                                       $body.find('#login-popup-overlay').show();
                                   });
                               } else {
                                   let phone_checkbox_found = false;
                                   for (let selector of response_data.error_fields_selector) {
                                       $body.find(selector).addClass('register-popup-error');
                                   }
                                   for (let selector of response_data.error_message_selector) {
                                       $body.find(selector).show();

                                       if (selector === '#register_phone_error_checkbox') {
                                           phone_checkbox_found = true;
                                       }
                                   }
                                   if (phone_checkbox_found) {
                                       $body.find('#register-agree-to-get-sms').closest('.custom-checkbox-container').find('.custom-checkbox').attr('style', 'border-color:red;');
                                       $body.find('#register-agree-to-get-sms').closest('.custom-checkbox-container').find('.custom-checkbox-label').attr('style', 'color:red;');
                                   } else {
                                       $body.find('#register-agree-to-get-sms').closest('.custom-checkbox-container').find('.custom-checkbox').attr('style', '');
                                       $body.find('#register-agree-to-get-sms').closest('.custom-checkbox-container').find('.custom-checkbox-label').attr('style', '');
                                   }
                               }
                               return;
                           }
                           //Google analytics
                           dataLayer.push({
                                              _event: 'account_created',
                                              event:  'Account Created',
                                          });
                           window.location.href = response_data.url;

                       },
                       error:    function(response_data) {
                           $body.find('#register-popup-submit-btn').removeClass('btn-disabled');
                           console.log(response_data);
                       },
                   });

            return;
            ajaxRegister(email, password, firstName, lastName).done(function(html) {
                // logic for registration errors
                if (html.indexOf('Email is invalid') !== -1) {
                    alert(html.indexOf('Email is invalid'));
                    $body.find('#register_popup_email').addClass('register-popup-error');
                    $body.find('#register_popup_email_err_message').show();
                }

                    //         else if(html.indexOf('This email address is already associated with an account')) {

                    //           $body.find('#register_popup_email').addClass('register-popup-error');
                    //           $body.find('#register_popup_email_exists_err_message').show();
                //         }

                else {
                    window.location.reload();
                }
                $body.find('#register-popup-submit-btn')[0].removeAttribute('disabled');

            });

        }
    });

    //   $body.on('click', '#login-popup-submit-btn', function() {
    //     $body.find('#login-popup-submit-btn').attr('disabled', 'disabled');
    //     let email = $body.find('#login_popup_email').val().trim();
    //     $body.find('#login-popup-form').
    //     find('input').
    //     removeClass('login-popup-error');
    //     $body.find('#login-popup-form').find('.login-popup-error-msg').hide();
    //     if (!validateEmail(email)) {
    //       $body.find('#login_popup_email').addClass('login-popup-error');
    //       $body.find('#login_popup_email_err_message').show();
    //       $body.find('#login-popup-submit-btn')[0].removeAttribute('disabled');
    //       return;
    //     }

    //     let password = $body.find('#login_popup_password').val().trim();
    //     ajaxLogin(email, password).done(function(html) {
    //       if (html.indexOf('Incorrect email or password') !== -1) {
    //         $body.find('#login_popup_login_err_message').show();
    //       } else {
    //         window.location.reload();
    //         return;
    //       }
    //       $body.find('#login-popup-submit-btn')[0].removeAttribute('disabled');
    //     });

    //   });

    $body.on('click', '#forgot-popup-submit-btn', function() {
        if (rb_breaker < rb_breaker_limit || $body.find('#login_popup_hp').val().trim() !== '') {
            showLoginCaptcha();
            rb_breaker = 0;
            return;
        }
        rb_breaker = 0;
        $body.find('#forgot-popup-submit-btn').addClass('btn-disabled');
        $body.find('#forgot_popup_email_err_message').hide();

        $.ajax({
                   url:      'https://app.yellowshoes.com/api/multipass',
                   method:   'POST',
                   data:     {
                       'action':   'forgot_pass',
                       'email':    $body.find('#forgot_popup_email').val().trim(),
                       'language': theme.locale,
                   },
                   dataType: 'json',
                   success:  function(response_data) {
                       $body.find('#forgot-popup-submit-btn').removeClass('btn-disabled');
                       if (!response_data.success) {
                           $body.find('#forgot_popup_email_err_message').text(response_data.error_message).show();
                           return;
                       }
                       //         $body.find('#login-popup-overlay').hide();
                       $body.find('#reset-email').text($body.find('#forgot_popup_email').val().trim());
                       $body.find('#forgot_popup_email').val('');

                       //         $body.find('#forgot-popup-form').find('.popup-blank-btn')[0].click();

                       $body.find('#forgot-popup-success').show();
                   },
                   error:    function(response_data) {
                       $body.find('#forgot-popup-submit-btn').removeClass('btn-disabled');
                       console.log(response_data);
                   },
               });

        return;
        $body.find('#forgot-popup-submit-btn').attr('disabled', 'disabled');
        $body.find('#forgot-success').hide();
        let email = $body.find('#forgot_popup_email').val().trim();
        $body.find('#forgot-popup-form').
              find('input').
              removeClass('login-popup-error');
        $body.find('#forgot-popup-form').find('.login-popup-error-msg').hide();
        if (!validateEmail(email)) {
            $body.find('#forgot_popup_email').addClass('login-popup-error');
            $body.find('#forgot_popup_email_err_message').show();
            $body.find('#forgot-popup-submit-btn')[0].removeAttribute('disabled');
            return;
        }

        ajaxReset(email).done(function(html) {
            $body.find('#reset-email').text($body.find('#forgot_popup_email').val());
            $body.find('#forgot_popup_email').val('');
            $body.find('#forgot-popup-success').show();
            setTimeout(function() {
                $body.find('#forgot-popup-success').hide();
            }, 7000);
            $body.find('#forgot-popup-submit-btn')[0].removeAttribute('disabled');
        });

    });

    $body.on('click', '#login-popup-overlay .popup-blank-btn,#login-popup-overlay .login-popup-tab-changer', function() {
        $body.find('.login-popup-tab').hide();
        $body.find($(this).attr('data-target')).show();
    });

    $body.on('click', '.login-popup-close', function() {
        $body.find('#login-popup-overlay').hide();
        $body.removeClass('ov-hidden');
    });

    $body.on('click', '#login-popup-submit-btn', function() {
        if (rb_breaker < rb_breaker_limit || $body.find('#login_popup_hp').val().trim() !== '') {
            showLoginCaptcha();
            rb_breaker = 0;
            return;
        }
        rb_breaker = 0;

        let redirect_url = $body.find('#login_popup_redirect_url').val().trim();
        if (redirect_url === '') {
            redirect_url = window.location.href;
        }
        $body.find('#login-popup-submit-btn').addClass('btn-disabled');
        let email = $body.find('#login_popup_email').val().trim();
        $body.find('#login-popup-form').
              find('input').
              removeClass('login-popup-error');
        $body.find('#login-popup-form').find('.login-popup-error-msg').hide();

        let password = $body.find('#login_popup_password').val().trim();
        $.ajax({
                   url:      'https://app.yellowshoes.com/api/multipass',
                   method:   'POST',
                   data:     {
                       'action':       'login',
                       'email':        email,
                       'password':     password,
                       'language':     theme.locale,
                       'redirect_url': redirect_url,
                   },
                   dataType: 'json',
                   success:  function(response_data) {
                       if (!response_data.success) {
                           $body.find('#login_popup_email_err_message').html(response_data.error_message).show();

                           $body.find('#login-popup-submit-btn').removeClass('btn-disabled');
                           return;
                       }

                       window.location.href = response_data.url;
                   },
                   error:    function(response_data) {
                       $body.find('#login-popup-submit-btn').removeClass('btn-disabled');
                       console.log(response_data);
                   },
               });
        return;

        ajaxLogin(email, password).done(function(html) {
            if (html.includes('To continue, let us know you')) {
                window.location.href = '/challenge';
                //$("#login-popup-container").html(content);
            }
            //       if (html.indexOf('Incorrect email or password') !== -1) {
            //         $body.find('#login_popup_login_err_message').show();
            //       } else {
            //         window.location.reload();
            //         return;
            //       }
            $body.find('#login-popup-submit-btn')[0].removeAttribute('disabled');
        });

    });

    if ($(window).width() <= 900) {
        let html = $body.find('#mobile-account-menu-link-html').html();
        $body.find('#mobile-account-menu-link-html').remove();
        $body.find('#desktop-footer').remove();
        $body.find('.navigation__tier-1').prepend(html);

        setTimeout(function() {
            $body.find('#product-recommendations .product-block').addClass('product-recommendation-carousel-item');
            $body.find('#product-recommendations .product-block').each(function(index, el) {
                if (index != 0) {
                    $(this).addClass('product-recommendation-carousel-item-hidden');
                }
            });

        }, 500);

        //     $body.find('.mobile-nav-top').hide();
        //     $body.on('click','.navigation__item--with-children a', function(){
        //       $body.find('.mobile-nav-top').show();
        //       $body.find('.mobile-nav-top-account').hide();
        //     });
        //     $body.on('click','.mobile-nav-back', function(){
        //       $body.find('.mobile-nav-top').hide();
        //       $body.find('.mobile-nav-top-account').show();
        //       $body.find('.mobile-account-trigger').hide();
        //     });

        //     $body.on('click','.mobile-nav-top-account:not(.sign-in)', function(){
        //       $body.find('.mobile-account-trigger a').trigger('click');
        //       $body.find('.mobile-account-trigger').show();
        //       //       $body.find('.mobile-nav-top').show();
        //       //       $body.find('.mobile-nav-top-account').hide();
        //     });

    } else {
        $body.find('#mobile-footer').remove();
    }

    $body.on('click', '.signup-mobile-link', function(e) {
        e.preventDefault();
        window.location.href = $(this).closest('li').find('.navigation__link').attr('href');
        $body.find('.navigation__mobile-header').find('.mobile-nav-toggle')[0].click();
    });
    $body.on('click', '.section-footer__title.mobile', function() {
        let $container = $(this).closest('div');
        let show       = true;
        if ($container.hasClass('active')) {
            show = false;
        }
        $body.find('.section-footer__menu-block').removeClass('active');
        if (show) {
            $container.addClass('active');
        }
    });

    $body.on('click', '#availability-btn', function() {
        let $quickbuy = $(this).closest('.quickbuy-content');
        if ($quickbuy.length) {
            let variant_id = $quickbuy.find('.original-selector').val();
            $quickbuy.find('#availability-reminder-variant-id').val(variant_id);
        } else {
            let $_GET = getQueryStringParameters();

            if ($_GET.variant !== undefined) {
                $body.find('#availability-reminder-variant-id').val($_GET.variant);
            }
        }

    });
    $body.on('mouseover', '.featured-block.product-block-options__item', function() {
        let sku   = $(this).attr('data-sku');
        let $this = $(this);
        $this.closest('.product-block').attr('data-sku', sku);
        let $link = $(this).closest('.product-block').find('.product-link');
        let url   = $link.attr('href');
        url       = url.split('?')[0];
        url += '?variant=' + $(this).attr('data-variant-id');
        $link.attr('href', url);

        if ($(this).attr('data-image').trim() !== '') {
            if ($(this).closest('.product-block').find('.featured-product-image').length > 0) {
                $(this).closest('.product-block').find('.featured-product-image').attr('src', $(this).attr('data-image'));
            } else {
                $(this).closest('.product-block').find('.rimage__image').attr('src', $(this).attr('data-image'));
                $(this).closest('.product-block').find('.rimage__image').attr('srcset', $(this).attr('data-image'));
            }

        }

        if (theme.customer_logged_in) {
            $.ajax({
                       url:     'https://apps-yellow.meginteractive.net/api/wishlist',
                       method:  'POST',
                       data:    {
                           action: 'check-item',
                           email:  theme.customer_email,
                           sku:    sku,
                       },
                       success: function(response_data) {
                           response_data = JSON.parse(response_data);
                           if (response_data.success !== undefined && response_data.success) {
                               if (response_data.exists) {
                                   $this.closest('.product-block').find('.wishlist-selected').removeClass('wishlist-hidden');
                                   $this.closest('.product-block').find('.wishlist-unselected').addClass('wishlist-hidden');
                               } else {
                                   $this.closest('.product-block').find('.wishlist-selected').addClass('wishlist-hidden');
                                   $this.closest('.product-block').find('.wishlist-unselected').removeClass('wishlist-hidden');
                               }
                           }
                       },
                       error:   function(response_data) {
                           console.log(response_data);
                       },
                   });
        }
    });

    $body.on('click', '.close-fancy', function() {
        $body.find('.fancybox-button').trigger('click');
    });

    $body.on('click', '#availability-reminder-submit-btn', function() {
        $body.find('.availability-reminder-input').removeClass('border-danger');
        $body.find('#availability-reminder-error').attr('style', 'opacity:0;').text('');
        $body.find('[data-target="#agree-to-get-sms"]').removeClass('border-danger');
        $body.find('[data-target="#agree-to-get-sms"]').closest('.custom-checkbox-container').find('.custom-checkbox-label').removeClass('text-danger');
        $.ajax({
                   url:      'https://app.yellowshoes.com/api/availability-reminders',
                   method:   'POST',
                   data:     {
                       action:           'record email',
                       variant_id:       $body.find('#availability-reminder-variant-id').val().trim(),
                       email:            $body.find('#availability-reminder-email').val().trim(),
                       phone:            $body.find('#availability-reminder-phone').val().trim(),
                       postal_code:      $body.find('#availability-reminder-zip').val().trim(),
                       signup_for_sms:   $body.find('#agree-to-get-sms')[0].checked ? '1' : '0',
                       signup_for_email: $body.find('#agree-to-get-email')[0].checked ? '1' : '0',

                       language: theme.locale,
                   },
                   dataType: 'json',
                   success:  function(response_data) {
                       if (response_data.success) {
                           $body.find('.fancybox-button').trigger('click');
                           $body.find('.availability-reminder-input:not(#availability-reminder-variant-id)').val('');
                           setTimeout(function() {

                               new Swal({
                                            title: '',
                                            text:  '',
                                            icon:  'success',
                                        });
                           }, 250);
                           // $body.find('.fancybox-button')[0].click();
                       } else {
                           if (response_data.fields !== undefined) {
                               for (let el of response_data.fields) {
                                   $body.find(el).addClass('border-danger');
                                   $body.find('#availability-reminder-error').
                                         html(response_data.message).
                                         attr('style', 'opacity:1;');
                                   if (el == '#availability-reminder-phone-checkbox') {
                                       $body.find('[data-target="#agree-to-get-sms"]').addClass('border-danger');
                                       $body.find('[data-target="#agree-to-get-sms"]').closest('.custom-checkbox-container').find('.custom-checkbox-label').addClass('text-danger');
                                   }
                               }

                           }
                       }

                   },
                   error:    function(response_data) {
                   },
               });

    });
    $body.on('click', '#footer-sub-btn', function() {

        $.ajax({
                   url:     'https://app.yellowshoes.com/api/shopify-subscribe-form-listrak',
                   method:  'POST',
                   data:    {
                       email: $body.find('#footer-sub-input').val().trim(),
                   },
                   success: function(response_data) {
                       $body.find('#footer-sub-error').text('').hide();
                       response_data = JSON.parse(response_data);
                       if (response_data.success) {
                           $body.find('#footer-sub-input').val('');
                           new Swal({
                                        title: '',
                                        text:  '',
                                        icon:  'success',
                                    });
                       } else {
                           if (response_data.message !== undefined) {
                               $body.find('#footer-sub-error').
                                     html(response_data.message).
                                     show();
                           }
                       }
                   },
                   error:   function(response_data) {
                       console.log(response_data);
                   },
               });
    });

    /*wishlist*/

    if (!theme.customer_logged_in) {
        let wishlist_url = '';
        if (theme.locale === 'fr') {
            wishlist_url += '/fr';
        }
        wishlist_url += '/account/login?return=' + encodeURIComponent(window.location.href);
        setTimeout(function() {
            $body.find('.wishlist-item').find('a').attr('href', wishlist_url);
        }, 500);
    }

    $body.on('click', '.wishlist-item', function(e) {
        e.preventDefault();
        if (!theme.customer_logged_in) {
            showLogin();
            return;
        }
        let $this = $(this);

        let product_id  = $(this).closest('.product-block').attr('data-product-id');
        let product_url = $(this).closest('.product-block').find('.product-link').attr('href');
        product_url     = product_url.split('/fr/').join('/');
        let sku         = $(this).closest('.product-block').attr('data-sku');
        $.ajax({
                   url:     'https://apps-yellow.meginteractive.net/api/wishlist',
                   method:  'POST',
                   data:    {
                       email:       theme.customer_email,
                       first_name:  theme.customer_first_name,
                       last_name:   theme.customer_last_name,
                       action:      'add-remove-wishlist',
                       product_id:  product_id,
                       product_url: product_url,
                       sku:         sku,
                   },
                   success: function(response_data) {
                       response_data = JSON.parse(response_data);
                       if (response_data.success !== undefined && response_data.success) {
                           if (response_data.removed) {
                               if ($this.find('.fa-trash').length > 0) {
                                   $this.closest('.product-block').remove();
                                   if ($body.find('#items-container .product-block').length == 0) {
                                       $body.find('#no-items-container').show();
                                   }
                               } else {
                                   $this.find('.wishlist-selected').addClass('wishlist-hidden');
                                   $this.find('.wishlist-unselected').removeClass('wishlist-hidden');
                               }
                           } else {
                               $this.find('.wishlist-unselected').addClass('wishlist-hidden');
                               $this.find('.wishlist-selected').removeClass('wishlist-hidden');
                           }

                           if (response_data.removed != undefined && response_data.removed == true && $('#number-items').length > 0) {
                               var count = $('#number-items').find('div').html();
                               count     = parseInt(count) - 1;
                               if (count == 1) {
                                   $('#number-items').html('<div style=\'padding:16px 0;\'>' + count + ' item</div>');
                               } else {
                                   $('#number-items').html('<div style=\'padding:16px 0;\'>' + count + ' items</div>');
                               }
                           }
                           updateCount();
                       }
                   },
                   error:   function(response_data) {
                       console.log(response_data);
                   },
               });
    });
    setTimeout(function() {
        getWishlistItems();
        updateCount();
    }, 500);

    //   let wishlist_mouse_over = false;
    //   $body.on('mouseover', '.wishlist-item', function(){
    //     if(!wishlist_mouse_over){
    //       $(this).find('.wishlist-unselected').hasClass('wishlist-hidden')
    //       ? $(this).find('.wishlist-unselected').removeClass('wishlist-hidden')
    //       : $(this).find('.wishlist-unselected').addClass('wishlist-hidden');

    //       $(this).find('.wishlist-selected').hasClass('wishlist-hidden')
    //       ? $(this).find('.wishlist-selected').removeClass('wishlist-hidden')
    //       : $(this).find('.wishlist-selected').addClass('wishlist-hidden');
    //       wishlist_mouse_over = true;
    //     }

    //   });
    //   $body.on('mouseleave', '.wishlist-item', function(){
    //     if(wishlist_mouse_over){
    //       $(this).find('.wishlist-unselected').hasClass('wishlist-hidden')
    //       ? $(this).find('.wishlist-unselected').removeClass('wishlist-hidden')
    //       : $(this).find('.wishlist-unselected').addClass('wishlist-hidden');

    //       $(this).find('.wishlist-selected').hasClass('wishlist-hidden')
    //       ? $(this).find('.wishlist-selected').removeClass('wishlist-hidden')
    //       : $(this).find('.wishlist-selected').addClass('wishlist-hidden');
    //       wishlist_mouse_over = false;
    //     }

    //   });

    /*end.wishlist*/
    sortSlider('.megint-slider', true);
    $body.on('click', '.small-feature-link', function() {
        let selector = '#' + $(this).closest('.megint-slider').attr('id');
        sortSlider(selector);
        $(this).closest('.megint-slider').find('.meginst-carousel').animate({scrollLeft: 0}, 800);
    });

    //   if($body.find('.small-feature-link').length){
    //     $body.find('#best-sellers-section .small-feature-link')[0].click();
    //   }
    setTimeout(function() {
        $body.find('.megint-slider').each(function(index, el) {
            if ($(this).find('.small-feature-link').length) {
                $(this).find('.small-feature-link').eq(0)[0].click();
            }
        });
    }, 500);

    $body.on('click', '.best-sellers-next', function() {
        // console.log('clicked .best-sellers-next');
        let accepted_length = 0;
        let $parent_el      = $(this).closest('.meginst-carousel');
        let $parent         = $parent_el.find('.carousel-item').parent();

        if ($parent_el.find('.carousel-item').length > accepted_length) {
            $parent_el.find('.carousel-item-hidden').each(function() {
                $(this).clone().appendTo($parent);
                $(this).remove();
            });

            let $el_to_hide = $parent_el.find('.carousel-item:not(.carousel-item-hidden)').eq(0);
            let $el_to_show = $parent_el.find('.carousel-item-hidden').eq(0);

            $el_to_hide.addClass('carousel-item-hidden');
            let $clone = $el_to_hide.clone().appendTo($parent);
            $el_to_hide.remove();
            $el_to_show.removeClass('carousel-item-hidden');
        }
    });

    $body.on('click', '.best-sellers-prev', function() {
        let accepted_length = 0;
        let $parent_el      = $(this).closest('.meginst-carousel');
        let $parent         = $parent_el.find('.carousel-item').parent();
        if ($parent_el.find('.carousel-item').length > accepted_length) {
            let $cloned_items = [];
            $parent_el.find('.carousel-item-hidden').each(function() {
                $cloned_items.push($(this).clone());
                $(this).remove();
            });
            $cloned_items = $cloned_items.reverse();
            for (let cloned_item of $cloned_items) {
                cloned_item.prependTo($parent);
            }
            let $el_to_hide         = $parent_el.find('.carousel-item:not(.carousel-item-hidden)').eq($parent_el.find('.carousel-item:not(.carousel-item-hidden)').length - 1);
            let $el_to_show         = $parent_el.find('.carousel-item-hidden').eq($parent_el.find('.carousel-item-hidden').length - 1);
            let $el_to_insert_after = $parent_el.find('.carousel-item-hidden').eq($parent_el.find('.carousel-item-hidden').length - 1);

            $el_to_hide.addClass('carousel-item-hidden');
            //       let $clone  = $el_to_hide.clone().insertAfter($el_to_insert_after);
            let $clone = $el_to_hide.clone().prependTo($parent);
            $el_to_hide.remove();
            $el_to_show.removeClass('carousel-item-hidden');
        }

    });

    $body.on('click', '.meginst-next', function() {
        let accepted_length = 0;
        let $parent_el      = $(this).closest('.meginst-carousel');
        let $parent         = $parent_el.find('.carousel-item').parent();

        if ($parent_el.find('.carousel-item').length > accepted_length) {
            $parent_el.find('.carousel-item-hidden').each(function() {
                $(this).clone().appendTo($parent);
                $(this).remove();
            });

            let $el_to_hide = $parent_el.find('.carousel-item:not(.carousel-item-hidden)').eq(0);
            let $el_to_show = $parent_el.find('.carousel-item-hidden').eq(0);

            $el_to_hide.addClass('carousel-item-hidden');
            let $clone = $el_to_hide.clone().appendTo($parent);
            $el_to_hide.remove();
            $el_to_show.removeClass('carousel-item-hidden');
        }
    });

    $body.on('click', '.meginst-prev', function() {
        let accepted_length = 0;
        let $parent_el      = $(this).closest('.meginst-carousel');
        let $parent         = $parent_el.find('.carousel-item').parent();
        if ($parent_el.find('.carousel-item').length > accepted_length) {
            let $cloned_items = [];
            $parent_el.find('.carousel-item-hidden').each(function() {
                $cloned_items.push($(this).clone());
                $(this).remove();
            });
            $cloned_items = $cloned_items.reverse();
            for (let cloned_item of $cloned_items) {
                cloned_item.prependTo($parent);
            }
            let $el_to_hide         = $parent_el.find('.carousel-item:not(.carousel-item-hidden)').eq($parent_el.find('.carousel-item:not(.carousel-item-hidden)').length - 1);
            let $el_to_show         = $parent_el.find('.carousel-item-hidden').eq($parent_el.find('.carousel-item-hidden').length - 1);
            let $el_to_insert_after = $parent_el.find('.carousel-item-hidden').eq($parent_el.find('.carousel-item-hidden').length - 1);

            $el_to_hide.addClass('carousel-item-hidden');
            //       let $clone  = $el_to_hide.clone().insertAfter($el_to_insert_after);
            let $clone = $el_to_hide.clone().prependTo($parent);
            $el_to_hide.remove();
            $el_to_show.removeClass('carousel-item-hidden');
        }
    });

    $body.on('click', '.categories-next', function() {
        let accepted_length = 0;
        let $slider         = $(this).closest('.meg-cat-slider');
        if (!$slider.length) {
            return;
        }
        if ($slider.find('.category-carousel-item').length > accepted_length) {
            $slider.find('.category-carousel-item-hidden').each(function() {
                $(this).clone().appendTo('#mobile-categories');
                $(this).remove();
            });

            let $el_to_hide = $slider.find('.category-carousel-item:not(.category-carousel-item-hidden)').eq(0);
            let $el_to_show = $slider.find('.category-carousel-item-hidden').eq(0);

            $el_to_hide.addClass('category-carousel-item-hidden');
            let $clone = $el_to_hide.clone().appendTo('#mobile-categories');
            $el_to_hide.remove();
            $el_to_show.removeClass('category-carousel-item-hidden');
        }
    });

    $body.on('click', '.categories-prev', function() {
        let accepted_length = 0;
        let $slider         = $(this).closest('.meg-cat-slider');
        if ($slider.find('.category-carousel-item').length > accepted_length) {
            let $cloned_items = [];
            $slider.find('.category-carousel-item-hidden').each(function() {
                $cloned_items.push($(this).clone());
                $(this).remove();
            });
            $cloned_items = $cloned_items.reverse();
            for (let cloned_item of $cloned_items) {
                cloned_item.prependTo('#mobile-categories');
            }
            let $el_to_hide         = $slider.find('.category-carousel-item:not(.category-carousel-item-hidden)').eq($body.find('.category-carousel-item:not(.category-carousel-item-hidden)').length - 1);
            let $el_to_show         = $slider.find('.category-carousel-item-hidden').eq($body.find('.category-carousel-item-hidden').length - 1);
            let $el_to_insert_after = $slider.find('.category-carousel-item-hidden').eq($body.find('.category-carousel-item-hidden').length - 1);

            $el_to_hide.addClass('category-carousel-item-hidden');
            //       let $clone  = $el_to_hide.clone().insertAfter($el_to_insert_after);
            let $clone = $el_to_hide.clone().prependTo('#mobile-categories');
            $el_to_hide.remove();
            $el_to_show.removeClass('category-carousel-item-hidden');
        }
    });

    $body.on('click', '.product-recommendations-next', function() {
        let accepted_length = 0;
        if ($body.find('.product-recommendation-carousel-item').length > accepted_length) {
            $body.find('.product-recommendation-carousel-item-hidden').each(function() {
                $(this).clone().appendTo('#product-recommendations .product-list');
                $(this).remove();
            });

            let $el_to_hide = $body.find('.product-recommendation-carousel-item:not(.product-recommendation-carousel-item-hidden)').eq(0);
            let $el_to_show = $body.find('.product-recommendation-carousel-item-hidden').eq(0);

            $el_to_hide.addClass('product-recommendation-carousel-item-hidden');
            let $clone = $el_to_hide.clone().appendTo('#product-recommendations .product-list');
            $el_to_hide.remove();
            $el_to_show.removeClass('product-recommendation-carousel-item-hidden');
        }
    });

    $body.on('click', '.quickbuy-toggle', function() {
        setTimeout(function() {
            getWishlistItems();
        }, 2000);
    });
    $body.on('click', '.product-recommendations-prev', function() {
        let accepted_length = 0;
        if ($body.find('.product-recommendation-carousel-item').length > accepted_length) {
            let $cloned_items = [];
            $body.find('.category-carousel-item-hidden').each(function() {
                $cloned_items.push($(this).clone());
                $(this).remove();
            });
            $cloned_items = $cloned_items.reverse();
            for (let cloned_item of $cloned_items) {
                cloned_item.prependTo('#product-recommendations .product-list');
            }
            let $el_to_hide         = $body.find('.product-recommendation-carousel-item:not(.product-recommendation-carousel-item-hidden)').eq($body.find('.category-carousel-item:not(.category-carousel-item-hidden)').length - 1);
            let $el_to_show         = $body.find('.product-recommendation-carousel-item-hidden').eq($body.find('.product-recommendation-carousel-item-hidden').length - 1);
            let $el_to_insert_after = $body.find('.product-recommendation-carousel-item-hidden').eq($body.find('.product-recommendation-carousel-item-hidden').length - 1);

            $el_to_hide.addClass('product-recommendation-carousel-item-hidden');
            //       let $clone  = $el_to_hide.clone().insertAfter($el_to_insert_after);
            let $clone = $el_to_hide.clone().prependTo('#product-recommendations .product-list');
            $el_to_hide.remove();
            $el_to_show.removeClass('product-recommendation-carousel-item-hidden');
        }
    });

    if ($(window).width() <= 900) {
        $body.find('.video-container').each(function() {
            let $video = $(this).find('video');
            if ($video.length) {
                let height = $video[0].videoHeight;
                $video[0].addEventListener('loadedmetadata', function(e) {
                    // Print the native height of the video
                    let width  = $(this).closest('.video-container').width();
                    let ratio  = this.videoHeight / this.videoWidth;
                    let height = width * ratio;
                    $(this).closest('.video-container').attr('style', 'height:' + height + 'px;');
                    // Print the native width of the video
                    //           console.log(this.videoWidth);
                });
                //
            }
        });
    }

    $body.on('click', '.announcement-default-next', function(e) {
        e.preventDefault();
        let last_element_index = $body.find('.announcement-bar__inner').length - 1;
        let $visible_container = $body.find('.announcement-bar__inner:not(.hidden');

        $body.find('.announcement-bar__inner').addClass('hidden');

        let next_index = 0;
        if ($body.find('.announcement-bar__inner').index($visible_container[0]) != last_element_index) {
            next_index = $body.find('.announcement-bar__inner').index($visible_container[0]) + 1;
        }
        $body.find('.announcement-bar__inner').eq(next_index).removeClass('hidden');
    });

    $body.on('click', '.announcement-default-prev', function(e) {
        e.preventDefault();
        let last_element_index = $body.find('.announcement-bar__inner').length - 1;
        let $visible_container = $body.find('.announcement-bar__inner:not(.hidden');

        $body.find('.announcement-bar__inner').addClass('hidden');

        let next_index = $body.find('.announcement-bar__inner').index($visible_container[0]) - 1;
        if ($body.find('.announcement-bar__inner').index($visible_container[0]) == 0) {
            next_index = last_element_index;
        }
        $body.find('.announcement-bar__inner').eq(next_index).removeClass('hidden');

    });

    $body.on('click', '.announcement-next', function() {
        let last_element_index = $body.find('.announcement-bar-container').length - 1;
        let $visible_container = $body.find('.announcement-bar-container:not(.hidden');

        $body.find('.announcement-bar-container').addClass('hidden');

        let next_index = 0;
        if ($body.find('.announcement-bar-container').index($visible_container[0]) != last_element_index) {
            next_index = $body.find('.announcement-bar-container').index($visible_container[0]) + 1;
        }
        $body.find('.announcement-bar-container').eq(next_index).removeClass('hidden');
    });

    $body.on('click', '.announcement-prev', function() {
        let last_element_index = $body.find('.announcement-bar-container').length - 1;
        let $visible_container = $body.find('.announcement-bar-container:not(.hidden');

        $body.find('.announcement-bar-container').addClass('hidden');

        let next_index = $body.find('.announcement-bar-container').index($visible_container[0]) - 1;
        if ($body.find('.announcement-bar-container').index($visible_container[0]) == 0) {
            next_index = last_element_index;
        }
        $body.find('.announcement-bar-container').eq(next_index).removeClass('hidden');
    });

});

function startCountDown(selector) {
    let $body = $('body');
    setInterval(function() {
        let days    = Number($body.find(selector).find('.count-down-timer-days').text().trim());
        let hours   = Number($body.find(selector).find('.count-down-timer-hours').text().trim());
        let minutes = Number($body.find(selector).find('.count-down-timer-minutes').text().trim());
        let seconds = Number($body.find(selector).find('.count-down-timer-seconds').text().trim());
        if (days > 0) {
            seconds -= 1;
            if (seconds < 0) {
                seconds = 59;
                minutes -= 1;
            }
            if (minutes < 0) {
                minutes = 59;
                hours -= 1;
            }
            if (hours < 0) {
                hours = 23;
                days -= 1;
            }
        }

        if (days == 0 && hours > 0) {
            seconds -= 1;
            if (seconds < 0) {
                seconds = 59;
                minutes -= 1;
            }
            if (minutes < 0) {
                minutes = 59;
                hours -= 1;
            }
        }

        if (days == 0 && hours == 0) {
            seconds -= 1;
            if (seconds < 0) {
                seconds = 59;
                minutes -= 1;
            }
        }
        if (days == 0 && hours == 0 && minutes == 0) {
            seconds -= 1;
            if (seconds < 0) {
                seconds = 0;
            }
        }

        days    = days < 10 ? '0' + days : days;
        hours   = hours < 10 ? '0' + hours : hours;
        minutes = minutes < 10 ? '0' + minutes : minutes;
        seconds = seconds < 10 ? '0' + seconds : seconds;
        $body.find(selector).find('.count-down-timer-days').text(days);
        $body.find(selector).find('.count-down-timer-hours').text(hours);
        $body.find(selector).find('.count-down-timer-minutes').text(minutes);
        $body.find(selector).find('.count-down-timer-seconds').text(seconds);
    }, 1000);
}

function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
}

function removeCookie(name) {
    document.cookie = name + '=false; expires=Thu, 18 Dec 2013 12:00:00 UTC; path=/';
}

function setCookieForDays(c_name, value, exdays) {
    var exdate = new Date();
    exdate.setDate(exdate.getDate() + exdays);
    var c_value     = escape(value) + ((exdays == null) ? '' : '; expires=' + exdate.toUTCString() + '; path=/');
    document.cookie = c_name + '=' + c_value;
}

function setCookieForHours(c_name, value, exhours) {
    var exdate = new Date();
    exdate.setHours(exdate.getHours() + exhours);
    var c_value     = escape(value) + ((exhours == null) ? '' : '; expires=' + exdate.toUTCString() + '; path=/');
    document.cookie = c_name + '=' + c_value;
}

function showPopup(selector = '#some-selector') {
    let $body = $('body');
    $body.find(selector).show();
}

function showPreloader() {
    let $body = $('body');
    $body.find('#theme-preloader').show();
}

function hidePreloader() {
    let $body = $('body');
    $body.find('#theme-preloader').hide();
}

function ajaxRegister(email, password, firstName, lastName) {
    var data = {
        'customer[email]':      email,
        'customer[password]':   password,
        'customer[first_name]': firstName,
        'customer[last_name]':  lastName,
        form_type:              'create_customer',
        utf8:                   '✓',
    };

    var promise = $.ajax({
                             url:      '/account',
                             method:   'post',
                             data:     data,
                             dataType: 'html',
                             async:    true,
                         });

    return promise;
}

function ajaxLogin(email, password) {
    var data = {
        'customer[email]':    email,
        'customer[password]': password,
        form_type:            'customer_login',
        utf8:                 '✓',
    };

    var promise = $.ajax({
                             url:      '/account/login',
                             method:   'post',
                             data:     data,
                             dataType: 'html',
                             async:    true,
                         });

    return promise;
}

function ajaxReset(email, password) {
    var data = {
        'email':   email,
        form_type: 'recover_customer_password',
        utf8:      '✓',
    };

    var promise = $.ajax({
                             url:      '/account/recover',
                             method:   'post',
                             data:     data,
                             dataType: 'html',
                             async:    true,
                         });

    return promise;
}

function showLogin(show_login = false, redirect_url = '') {
    let $body = $('body');
    $body.addClass('ov-hidden');
    if (redirect_url !== '') {
        $body.find('#login_popup_redirect_url').val(redirect_url);
    }
    $body.find('#login-popup-overlay').show();
    if (show_login) {
        $body.find('#login-popup-wishlist-warning').hide();
    } else {
        $body.find('#login-popup-wishlist-warning').show();
    }

}

function hideLogin() {
    let $body = $('body');
    $body.find('#login-popup-overlay').hide();

}

function sortSlider(selector, each = false) {
    let $body          = $('body');
    let accepted_index = 0;
    let is_mobile      = false;
    if ($(window).width() > 900) {
        accepted_index = 2;
    } else {
        is_mobile = true;
    }
    if (each) {
        $body.find(selector).each(function() {
            $(this).find('.featured-product-block').removeClass('carousel-item');
            $(this).find('.featured-product-block').removeClass('carousel-item-hidden');
            if (is_mobile) {
                $(this).find('.meg-slider-prev').remove();
                $(this).find('.meg-slider-next').remove();
                $(this).addClass('meginst-scroll-wrapper');
                $(this).find('.meginst-carousel').addClass('meginst-scroll-content-wrapper');

                $(this).find('.product-block').addClass('d-inline-block-important').addClass('meginst-product-block-mobile');
                $(this).find('.meginst-carousel').attr('style', 'display:block;');
            } else {
                $(this).find('.featured-product-block:not(.hidden)').each(function(index, element) {
                    $(element).addClass('carousel-item');
                    if (index > accepted_index) {
                        $(element).addClass('carousel-item-hidden');
                    }
                });
            }

        });
    } else {
        $body.find(selector).find('.featured-product-block').removeClass('carousel-item');
        $body.find(selector).find('.featured-product-block').removeClass('carousel-item-hidden');
        if (is_mobile) {
            $body.find(selector).find('.meg-slider-prev').remove();
            $body.find(selector).find('.meg-slider-next').remove();
            $body.find(selector).addClass('meginst-scroll-wrapper');
            $body.find(selector).find('.meginst-carousel').addClass('meginst-scroll-content-wrapper');
            $body.find(selector).find('.product-block').addClass('d-inline-block-important').addClass('meginst-product-block-mobile');
            $body.find(selector).find('.meginst-carousel').attr('style', 'display:block;');
        } else {

            $body.find(selector).find('.featured-product-block:not(.hidden)').each(function(index, element) {
                $(element).addClass('carousel-item');
                if (index > accepted_index) {
                    $(element).addClass('carousel-item-hidden');
                }
            });
        }

    }

}

function getQueryStringParameters() {
    var parameters = {}, hash;
    var q          = document.URL.split('?')[1];
    if (q != undefined) {
        q = q.split('&');
        for (var i = 0; i < q.length; i++) {
            hash                = q[i].split('=');
            parameters[hash[0]] = hash[1];
        }
    }
    return parameters;
}

function getWishlistItems() {
    let $body = $('body');
    let skus  = '';
    $body.find('.wishlist-item').each(function() {
        let pContainer = $(this).closest('.product-block');
        let sku        = pContainer.attr('data-sku');
        skus += sku + ',';

    });
    $.ajax({
               url:     'https://apps-yellow.meginteractive.net/api/wishlist',
               method:  'POST',
               data:    {
                   action: 'check-items',
                   email:  theme.customer_email,
                   skus:   skus,
               },
               success: function(response_data) {
                   response_data = JSON.parse(response_data);
                   if (response_data.success !== undefined && response_data.success) {
                       $body.find('.wishlist-item').each(function() {
                           let pContainer = $(this).closest('.product-block');
                           let sku        = pContainer.attr('data-sku');
                           if ($(this).find('.fa-trash').length == 0) {
                               if (response_data.skus.indexOf(sku) == (-1)) {
                                   pContainer.find('.wishlist-selected').addClass('wishlist-hidden');
                                   pContainer.find('.wishlist-unselected').removeClass('wishlist-hidden');
                               } else {
                                   pContainer.find('.wishlist-unselected').addClass('wishlist-hidden');
                                   pContainer.find('.wishlist-selected').removeClass('wishlist-hidden');
                               }
                           }
                       });
                   }
               },
               error:   function(response_data) {
                   console.log(response_data);
               },
           });
}

function showLoginCaptcha(showPopup = true) {
    let $body = $('body');
    $body.find('#login-popup-overlay').hide();
    new Swal({
                 title: '',
                 html:  '<div class="text-center"">I\'m not a robot<div id="rb_breaker"></div></div>',
                 icon:  'warning',
             }).then((value) => {
        if ($body.find('#rb_breaker').html().trim() !== '✓') {
            showLoginCaptcha();
        } else {
            rb_breaker = 4;
            if (showPopup) {
                $body.find('#login-popup-overlay').show();
            }
        }
    });
}

function updateCount() {
    let $body = $('body');
    $.ajax({
               url:     'https://apps-yellow.meginteractive.net/api/wishlist',
               method:  'POST',
               data:    {
                   action: 'get-items-count',
                   email:  theme.customer_email,
               },
               success: function(response_data) {
                   response_data = JSON.parse(response_data);
                   if (response_data.success !== undefined && response_data.success) {
                       $body.find('#wishlist-count').text(response_data.count);
                       $body.find('#wishlist-count').show();
                   }
               },
               error:   function(response_data) {
                   console.log(response_data);
               },
           });
}

function validateEmail(email) {
    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
}

